import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

const LinkAsPopUp = props => {
    const {
        details: {
            name,
            className,
            linkClassName,
            text,
            path,
            params
        },
        environment: {
            links
        },
        index
    } = props;
    
    const openAsPopUp = (link) => {
        window.open(link, '','width=380,height=495,toolbar=no,status=no,menubar=no,location=no,scrollbars=yes,resizable=yes,titlebar=no,dialog=yes' );
    };
    return (
        <Fragment>
            <li className={className}>
                <a
                    href={path}
                    className={linkClassName}
                    id={`${name}_${index}`}
                    data-automation-id={name}
                    onClick={ () => openAsPopUp(links[params])
                    }>
                    <FormattedMessage
                        id = {text}
                    />
                </a>
            </li>
        </Fragment>
    );


};

export default LinkAsPopUp;
